import { PromotionActionLocation } from '../../../../constants/analytics-enums';
import { useClaimPromoCode } from '../../hooks/useClaimPromoCode';

import { PromotionBonusModal } from "./PromotionBonusModal";
import type { BonusModalTemplateProps } from "./types";

export function ConnectedPromotionBonusModal({
  isOpen,
  onClose,
  onAction,
  promoCode,
  title,
  description,
  bonuses,
  dataTestId,
  actionButtonTestId,
  actionButtonLabel,
}: BonusModalTemplateProps) {
  const {
    claimPromoCode,
    claimError,
    isLoading,
  } = useClaimPromoCode(promoCode, PromotionActionLocation.PROMO_TAB, () => onAction());

  return (
    <PromotionBonusModal
      isOpen={isOpen}
      onClose={onClose}
      onAction={claimPromoCode}
      promoCode={promoCode}
      title={title}
      description={description}
      bonuses={bonuses}
      dataTestId={dataTestId}
      actionButtonTestId={actionButtonTestId}
      actionButtonLabel={actionButtonLabel}
      error={claimError}
      isLoading={isLoading}
    />
  )
}
